import { AsyncPipe } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  OnInit,
  output,
} from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Component({
  selector: 'transfer-type',
  templateUrl: './transfer-type.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [TranslateModule, AsyncPipe],
})
export class TransferTypeComponent implements OnInit {
  columnData: Observable<any> = new BehaviorSubject(null);
  additionData: Observable<any> = new BehaviorSubject(null);
  readonly onAction = output(); // {type:actionName,columnData }
  dataProperty: string = '';
  constructor() {}
  ngOnInit(): void {}

  splitCapitalCase(s: string) {
    return s.replace(/([A-Z])/g, ' $1').trim();
  }
}
